<template>
  <div class="container" v-title :data-title="$t('i18n.brandManage')">
    <div id="outer-title">{{ $t("i18n.brandManage") }}</div>
    <div v-loading="loading">
      <jl-table
        :tableData="tableData"
        @handleEdit="handleEdit"
        @handleDelete="handleDelete"
        @getEditData="getEditData"
        @init="init"
        :options="options"
        :columns="columns"
        :operates="operates"
        :total="total"
        :height="$defined.HEIGHT - 360 + 'px'"
      >
      </jl-table>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance } from "vue";
import { useI18n } from "vue-i18n";
import jlTable from "../../components/table";
export default {
  name: "Brand",
  components: {
    jlTable,
  },
  setup(props, { emit }) {
    emit("public_header", true);
    const { proxy } = getCurrentInstance();
    const { t } = useI18n();
    const state = reactive({
      formInline: {
        page: 1,
        pageSize: 10,
      },
      // table数据
      tableData: [],
      options: {
        // table 的参数
        isAdd: proxy.$defined.btnPermission("添加电梯品牌"), // 是否启用新增功能
        isEdit: proxy.$defined.btnPermission("编辑电梯品牌"), // 是否启用编辑功能
        isDelete: proxy.$defined.btnPermission("删除电梯品牌"), // 是否启用删除功能
        highlightCurrentRow: false, // 是否支持当前行高亮显示
        multiSelect: false, // 是否支持列表项选中功能
        pageShow: true, // 是否翻页
      },
      columns: [
        // 需要展示的列
        {
          prop: "number",
          label: "brandNo",
          align: "center",
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "name",
          label: "brandName",
          align: "left",
          search: true,
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "protocolType",
          label: "protocolOfBrand",
          align: "center",
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "lastModifyBy",
          label: "lastModifier",
          align: "center",
          row: false,
        },
        {
          prop: "lastModifiedDate",
          label: "lastModifyDate",
          align: "center",
          row: false,
        },
      ],
      operates: {
        // 列操作按钮
        width: 140,
        fixed: "right",
        list: [
          {
            id: "1",
            label: "export",
            icon: "el-icon-upload2",
            class: "export",
            show: true,
            type: "outer",
            method: (formInline) => {
              exportBrand(formInline);
            },
          },
        ],
      },
      total: 0,
      loading: true,
      editData: {},
    });

    const init = async (params) => {
      state.loading = true;
      const { data } = await proxy.$api.monitor.brandPages(params);
      state.tableData = data.records;
      state.total = data.total;
      state.loading = false;
    };

    const handleEdit = async (val, pages) => {
      // 新增/编辑数据
      let msg = val.id ? "edit" : "new";
      if (val.id) {
        for (let k in val) {
          if (val[k] !== undefined) {
            state.editData[k] = val[k];
          }
        }
        val = JSON.parse(JSON.stringify(state.editData));
      }
      val.id
        ? await proxy.$api.monitor.editBrandOne(val)
        : await proxy.$api.monitor.addBrandOne(val);
      proxy.$defined.tip(t("i18n." + msg) + t("i18n.success"), "success");
      // 初始化 刷新
      init(pages);
    };

    const handleDelete = (row, pages) => {
      proxy.$api.monitor.deleteBrand(row.id).then(() => {
        init(pages);
        proxy.$defined.tip(t("i18n.delete") + t("i18n.success"), "success");
      });
    };

    const getEditData = (row) => {
      state.editData = row;
    };

    const exportBrand = async (formInline) => {
      state.operates.list[0].loading = true;
      let res = await proxy.$api.monitor.exportBrand({
        name: formInline.name,
      });
      proxy.$defined.exportFunc(res);
      state.operates.list[0].loading = false;
    };

    return {
      ...toRefs(state),
      handleEdit,
      init,
      handleDelete,
      getEditData,
      exportBrand,
    };
  },
};
</script>
